import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fe4bff3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 1,
  class: "image is-32x32 part-thumbnail",
  "data-unit": "part-collection-thumbnail-placeholder"
}

import { ref, watch } from 'vue'
import StatelessThumbnail from '@/components/common/StatelessThumbnail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PartCollectionThumbnail',
  props: {
    thumbnailUrl: {},
    isWidget: { type: Boolean }
  },
  emits: ["preview"],
  setup(__props: any) {

const props = __props



const hasError = ref(false)

watch(() => props.thumbnailUrl, () => {
  hasError.value = false
})

return (_ctx: any,_cache: any) => {
  return (_ctx.thumbnailUrl && !hasError.value)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "part-thumbnail-preview-button",
        "data-unit": "part-collection-thumbnail-preview",
        "aria-label": _ctx.$t('clickToEnlarge'),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('preview')), ["stop"]))
      }, [
        _createVNode(StatelessThumbnail, {
          "is-widget": _ctx.isWidget,
          "thumbnail-url": _ctx.thumbnailUrl,
          "thumbnail-type": "part",
          class: "is-32x32 is-flex is-align-items-center",
          onErrorLoading: _cache[0] || (_cache[0] = ($event: any) => (hasError.value = true))
        }, null, 8, ["is-widget", "thumbnail-url"])
      ], 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("figure", _hoisted_2))
}
}

})